import React,{ useCallback, useEffect, useState } from 'react';
import Button from '../../components/Button/Button';
import './HalfPageBreif.css'
import NoResultsComponent from '../../components/NoResults/NoResult';
import Loader from '../../components/Loader/Loader';
import axios from '../../services/axiosInstance';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { fetchHalfPageBreif, smEvaluationProposalData } from '../../services/api';
import DocumentListItem from '../../components/HalfPage_Popup/DocumentListItem';
import { formatCurrency, formatDate, swapObject } from '../../util/util';
import CryptoUtils from '../../util/cryptoUtils';
import ProposalTitle from '../../components/ProposalTitle/ProposalTitle';
import DownloadDocPdf from '../../components/DownloadDocPdf/DownloadDocPdf';
import CEEvalViewAccordion from '../../components/CEEvalViewAccordion/CEEvalViewAccordion';
import CEEvalStatusToolTip from '../ToolTip/CEEvalStatusTooltip';
import infoIcon from '../../assets/images/icons/information-line.svg';
import { useDispatch } from 'react-redux';
import { setSPDetails } from '../../pages/Login/LoginSlice';
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import {Globals as OldGlobals} from '../../global/Globals';

export default function ProposalHalfSolicated(props) { 
  const {onClose, item, selectedInnerTableRowData, popupShow,isAuditTrail=false, page } = props
   const { Globals ,languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSynopsisExpanded, setIsSynopsisExpanded] = useState(false);
  const [contentData, setContentData] = useState([]);
  const [data, setData] = useState([]);
  const [proposalData, setProposalData] = useState(null);
  const [isLogLineExpanded, setIsLogLineExpanded] = useState(false);
  const [isepisodeStructureExpanded, setEpisodeStructureExpanded] = useState(false);
  const [isEditorialExpanded, setIsEditorialExpanded] = useState(false);
  const [isprojectStatusExpanded, setProjectStatusExpanded] = useState(false);
  const [isbrandIntegrationExpanded, setBrandIntegrationExpanded] = useState(false);
  const [isCompanyProfileExpanded, setCompanyProfileExpanded] = useState(false);
  const [iscastPresenterInfoExpanded, setCastPresenterInfoExpanded] = useState(false);
  const [islocationStudioInfoExpanded, setLocationStudioInfoExpanded] = useState(false);
  const [proposalError, setProposalError] = useState(null);
  const [fileItems, setFileItems] = useState([]);
  const [title, setTitle] = useState("");
  const [logLine, setLogLine] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [projectTitle, setProjectTitle] = useState("");
  const [editorialDetails, setEditorialDetails] = useState("");
  const [noOfEpisodes, setNoOfEpisodes] = useState(0);
  const [episodeDuration, setEpisodeDuration] = useState(0);
  const [targetAudience, setTargetAudience] = useState("");
  const [episodeStructure, setEpisodeStructure] = useState("");
  const [castPresenterInfo, setCastPresenterInfo] = useState("");
  const [locationStudioInfo, setLocationStudioInfo] = useState("");
  const [brandIntegration, setBrandIntegration] = useState("");
  const [keyTeams, setKeyTeams] = useState("");
  const [productionTimeLine, setProductionTimeLine] = useState("");
  const [artistName, setArtistName] = useState("");
  const [songName, setSongName] = useState("");
  const [targetBudget, setTargetBudget] = useState(0);
  const [currency, setCurrency] = useState("");
  const [projectStatus, setProjectStatus] = useState("");
  const [referenceLinks, setReferenceLinks] = useState("");
  const [proposalStatusHistories, setProposalStatusHistories] = useState([]);
  const [contentDataStatus, setContentDataStatus] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [BreifData, setBreifData] = useState([]);
  const [isExpand, setIsExpand] = useState(false);
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId").toString());
  const proposalBody = { proposalDetailId: proposalData?.[0]?.proposalDetailId?.toString(), proposalId: proposalData?.[0]?.proposalId, status: proposalData?.[0]?.evalStatus }
  const [proposalTitle, setProposaltitle] = useState()
  const [formatType, setFormatType] = useState('');
  const [ceEvalDetails, setCEEvalDetails] = useState(null);
  const [isUnsuccessfulMailSent, setIsUnsuccessFulMailSent] = useState(false);
  const [clusteredCEList, setClusteredCEList]=useState(null);
  const [existingCEList, setExistingCEList]=useState(null);
  const [producerType, setProducerType]=useState('');
  const [ceEvalAPIFailure, setCEEvalAPIFailure] = useState(false);
  const [isSMRoleAvailableInCluster, setIsSMRoleAvailableInCluster] = useState(false);
  const [isHOPRoleAvailableInCluster, setIsHOPRoleAvailableInCluster] = useState(false);
  const [isUnsuccessfulAfterSM, setIsUnsuccessfulAfterSM]=useState(false);
  const fetchProposalHalfPage = async () => {
    const proposalId = item.proposalId;
    const producerProposalDeatilId= item.proposalDetailId;
    try {
      let endPoint;
      if (roleID === '5') {
        endPoint = `${Globals.BASE_URL}/Solicited/GetSolicitedMinDisplayProposalByIdWithLifeCycleAsync?proposalId=${proposalId}&roleId=${CryptoUtils.getFromLocalStorage('roleId')}&proposalDetailId=${producerProposalDeatilId}`;
      }
      //This API is common for both CC and CE
      else if (roleID === OldGlobals.USER_ROLES.CC|| roleID===Globals.USER_ROLES.CE || roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID==="1" || roleID === OldGlobals.USER_ROLES.HOP) {
        const _propsalId = selectedInnerTableRowData?.proposalId;//item.proposalDetails[0].proposalId;
        const proposalDetailId=selectedInnerTableRowData?.proposalDetailId;//item.proposalDetails[0].proposalDetailId;
        endPoint = Globals.BASE_URL + Globals.ENDPOINT.CC_SOLICITED_HALF_SCREEN_MIN_DISPLAY +'proposalId='+ _propsalId+'&roleId='+CryptoUtils.getFromLocalStorage('roleId')+'&proposalDetailId='+proposalDetailId;
      }
      const response = await axios.get(endPoint);
      console.log("resp", response);
      setIsSMRoleAvailableInCluster(response?.data?.content?.isSMRoleInCluster);
      setIsHOPRoleAvailableInCluster(response?.data?.content?.isHOPRoleInCluster);
      setIsUnsuccessfulAfterSM(response?.data?.content?.isUnSuccefullAfterSMReview);
      return response;
    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
      console.error("Error in App component:", error);
    }
  };
  useEffect(() => {
    const getProposalData = async () => {
      const proposalId = item.proposalId;
      console.log("Item", proposalId);
      const producerId = "612a8e8a-64af-4925-88bd-aef7893f3d55";

      try {
        const response = await fetchProposalHalfPage();
        console.log("Full Response", response);
        //fix for app-dynamics, this is to call API to get CE eval only when eval status >= 2
        if (response?.data?.content?.evalStatus >= 2) {
          fetchCEEvalDetails();
        }
        if (response.status >= 200 && response.status < 294) {
          setProducerType(response?.data?.content?.producerType)
          setProposalData(
            Array.isArray(response?.data?.content)
              ? response.data.content
              : [response?.data?.content]
          );
          CryptoUtils.saveToLocalStorage('pKey', response?.data?.content?.producerId);
          setProposaltitle(response?.data?.content?.title || response?.data?.content?.projectTitle ? response?.data?.content?.title || response?.data?.content?.projectTitle :"");
        } else {
          new Error(`API returned an error: ${response.status}`);
        }
        if (response.data && response.data.content) {
          const content = response.data.content;
          setLogLine(content.logLine);
          setSynopsis(content.synopsis);
          setProjectTitle(content?.projectTitle);
          setTitle(content.title || "");
          setEditorialDetails(content.editorialDetails);
          setNoOfEpisodes(content.noOfEpisodes);
          setEpisodeDuration(content.episodeDuration);
          setTargetAudience(content.targetAudience);
          setEpisodeStructure(content.episodeStructure);
          setCastPresenterInfo(content.castPresenterInfo);
          setLocationStudioInfo(content.locationStudioInfo);
          setBrandIntegration(content.brandIntegration);
          setKeyTeams(content.keyTeams);
          setProductionTimeLine(content.productionTimeLine);
          setArtistName(content.artistName);
          setSongName(content.songName);
          setTargetBudget(content.targetBudget);
          setCurrency(content.currency);
          setProjectStatus(content.projectStatus);
          setReferenceLinks(content.referenceLinks);
          setProposalStatusHistories(content.proposalStatusHistories);
          setIsUnsuccessFulMailSent(content?.isUnsuccessfulMailSent);
          if (content && content.documents) {
            const allDocs = content.documents;
            const orderedItems = [];
            const desiredOrder = ["LBMB", "PRSCH", "SHWRL", "CPRC", "RDOC"];
            desiredOrder.forEach((docFor) => {
              const foundDoc = allDocs.find(
                (doc) => doc.documentFor === docFor
              );
              let heading = "";
              switch (docFor) {
                case "LBMB":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.LBMB;
                  break;
                case "PRSCH":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.PRSCH;
                  break;
                case "SHWRL":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.SHWRL;
                  break;
                case "CPRC":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.CPRC;
                  break;
                case "RDOC":
                  heading = Globals.SOLICITED_PROPOSAL.DOCUMENTS.RDOC;
                  break;
                default:
                  heading = foundDoc?.documentType || Globals.HALFSCREEN.DOCUMENT;
              }
              orderedItems.push({foundDoc, docFor, heading, isDownload: false});
            });
            setFileItems(orderedItems);
          } else {
            setFileItems([]);
          }

        }
      } catch (error) {
        console.error("Error in App component:", error);
        setContentDataStatus("Error");
        console.error("Error in App component:", error);

        setProposalError("Error fetching data. Please try again later.");
      }
    };

    getProposalData();
    if (proposalData?.[0]?.evalStatus >= 2 && proposalData?.[0]?.evalStatus !== 9) {
      fetchCEEvalDetails();
    }
    console.log("dat---", item);
    if (item) {
      console.log("Item changed:", item);
    }
  }, [item]);

  const getData = async () => {
    try {
      const proposalId = item?.proposalId || selectedInnerTableRowData?.proposalId;
      const result = await fetchHalfPageBreif(
        OldGlobals.ENDPOINT.HALFPAGE_BRIEF,
       proposalId
      );
      const {
        createdByName,
        closingDate,
        countryName,
        productionTypeName,
        channelName,
        formatName,
        languageName,
        genreName,
        contentTypeName,
        clusterName,
        description,
        submissionRequirements,
        evalAndSelection,
        commisioningEditors,
        briefTypeName,
        ceEvalDeadline,
        smEvalDeadline,
        producers
      } = result.content;
      setFormatType(result?.content?.formatType);
      setClusteredCEList(result?.content?.commisioningEditorsListByCluster);
      setExistingCEList(result?.content?.commisioningEditors);
      setContentData([
        { Description: description },
        { "Submission Requirements": submissionRequirements },
        { "Evaluation Process": evalAndSelection },
      ]);
      setBreifData([
        ...( roleID !== Globals.USER_ROLES.PRODUCER ? [{ name: Globals.TABLE_HEADERS.CREATEDBY, description: createdByName }] : []),
        { name: Globals.CLOSING_DATE, description: formatDate(closingDate) },
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.CHANNEL, description: channelName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.FORMAT, description: formatName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.COUNTRY, description: countryName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.PRODUCTIONTYPE, description: productionTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.SCRIPTED, description: contentTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.GENRE, description: genreName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.LANGUAGE, description: languageName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.UNSOLICITED_PROPOSAL_HALF.CLUSTER, description: clusterName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.CREATE_NEW_BRIEF.COMMISSIONING_EDITORS, description: commisioningEditors&&commisioningEditors.join(', ') || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        { name: Globals.BRIEF_TYPE, description: briefTypeName || Globals.HALF_PAGE_BRIEF_DETAILS.NA},
        (roleID !== Globals.USER_ROLES.PRODUCER ? { name: Globals.CE_EVALUATION_DEADLINE, description: ceEvalDeadline && formatDate(ceEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA } : []),
        (roleID !== Globals.USER_ROLES.PRODUCER ? { name: Globals.SM_EVALUATION_DEADLINE, description: smEvalDeadline && formatDate(smEvalDeadline) || Globals.HALF_PAGE_BRIEF_DETAILS.NA } : []),
        (roleID !== Globals.USER_ROLES.PRODUCER ? { name: Globals.BRIEF_DATA_KEYS.PRODUCERS, description: producers?.length > 0 && producers.join(', ') || Globals.HALF_PAGE_BRIEF_DETAILS.NA } : []),
        ...(roleID !== Globals.USER_ROLES.PRODUCER ? [] : []),
      ])
      setData([result?.content]);

    } catch (error) {
      console.error("Error in App component:", error);
      setContentDataStatus("Error");
      console.error('Error in App component:', error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  
  const handleReload = () => {
    getData();
  }
  
    const toggleSynopsis = () => {
      setIsSynopsisExpanded(!isSynopsisExpanded);
    };
    const toggleLogLine = () => {
      setIsLogLineExpanded(!isLogLineExpanded);
    };
    
    const toggleEpisode = () => {
      setEpisodeStructureExpanded(!isepisodeStructureExpanded);
    };
    const toggleeditorial = () => {
      setIsEditorialExpanded(!isEditorialExpanded);
    };
    const toggleBrand = () => {
      setBrandIntegrationExpanded(!isbrandIntegrationExpanded);
    };
    const toggleCompanyProfile = () =>{
      setCompanyProfileExpanded(!isCompanyProfileExpanded)
    }
    const toggleCast = () => {
      setCastPresenterInfoExpanded(!iscastPresenterInfoExpanded);
    };
    const toggleLocation = () => {
      setLocationStudioInfoExpanded(!islocationStudioInfoExpanded);
    };
  const statusImg = (statusCode) => {
    const Title = statusLabels[statusCode];
    if (!Title) {
      console.warn("No title found for status code:", statusCode);
      return null;
    }
    let title;
    title = Title?.toUpperCase().replace(/[- ]/g, "");
    const swappedObject = swapObject(Globals.SUMMARY_CARD_NAME);
    const imgKey = swappedObject[Title] || OldGlobals.IMG[title];
    const ky = imgKey?.toUpperCase();
    const imgPath = OldGlobals.IMG[ky];
    return imgPath;
  };

// Setting status flow for producer , cc and ce.
const statusFlow = () => {
  switch (roleID) {
    case OldGlobals.USER_ROLES.PRODUCER:
      return Globals.TIMELINE_STATUS.PRODUCER;
    case OldGlobals.USER_ROLES.CC:
      return Globals.TIMELINE_STATUS.CC;
    case OldGlobals.USER_ROLES.CE:
      return Globals.TIMELINE_STATUS.CE;
      case OldGlobals.USER_ROLES.SNR_MGR:
        return Globals.TIMELINE_STATUS.SM;
      case OldGlobals.USER_ROLES.HOP:
      return Globals.TIMELINE_STATUS.HOP;
        case OldGlobals.USER_ROLES.SA:
        return Globals.TIMELINE_STATUS.SA;
    default:
      return {};
  }
}
const statusLabels = statusFlow();

const findKeyByValue = (value) => {
  return Object.keys(statusLabels).find(key => statusLabels[key] === value);
};

  const currentStatus = proposalStatusHistories?.[0]?.currentStatus ?? 0;
  const isApplyButtonDisabled = currentStatus !== 3;

  const proposalStatus = proposalData?.[0]?.proposalStatusHistories
  .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0]?.status;

  const latestComment = proposalData?.[0]?.proposalStatusHistories
  .filter((item) => item.userComment)
  .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))[0]?.userComment;

  
  const handleReloadProp = () => {
    setContentDataStatus(null)
    fetchProposalHalfPage();
    if (proposalData?.[0]?.evalStatus >= 2) {
      fetchCEEvalDetails();
    }
  }

  const navigateToPage =() => {
   
       if(roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP){
        navigate(Globals.NAVPATH.SENIOR_MANAGER_EVALUATION_PAGE, {
          state: {activeHeader:item, selectedProposal: 'solicited',isVirtualPitchCompleted: proposalData?.[0].isVirtualPitchCompleted},
          });
       }else {
      navigate(Globals.NAVPATH.REVIEW_PROPOSALS, {
        state: {
          selectedProposal: 'solicited',
          proposalId: selectedInnerTableRowData?.proposalId,
          proposalDetailId: selectedInnerTableRowData?.proposalDetailId
      }
      });
    }
  }

    const fetchCEEvalDetails = async () => {
      const proposalId = item.proposalId;
      const proposalDeatilId = item.proposalDetailId;
      try {
        const response = await smEvaluationProposalData(proposalDeatilId, proposalId);
        setCEEvalDetails(response?.data?.content);
      }
      catch (error) {
        setCEEvalAPIFailure(true);
        console.error("Error in fetching CE evaluation details for unsolicited halfscreens :", error);
      }
    }
  const handleTitleChange = (newTitle)=>{
    setProposaltitle(newTitle)
  }

  /**
   * This func is to nav to producers details page with req data, so that on return route will be known
   */
  const handleProducerDetails = () => {
    const producerNavProps = {
      activeHeader: isAuditTrail?'auditTrails':'all_proposals',
      selectedTab: isAuditTrail?'':'solicited',
      proposalId: item?.proposalId,
      proposalDetailId: item.proposalDetailId,
      isFromHalfscreen:true,
      page:page
    }
    if (item?.producerType === Globals.HALFSCREEN.PRODUCER_TYPE.INDIVIDUAL) {
      navigate(Globals.NAVPATH.SYS_ADMIN_PRODUCER_APPROVE_REJECT, { state: { producerNavProps } })
    }
    else {
      navigate(Globals.NAVPATH.SYS_ADMIN_COMP_APPROVE_REJECT, { state: { producerNavProps } })
    }
  }

  /**
   * This useEffect is to store current/active proposal details in redux store
   */
  useEffect(() => {
    if (item) {
      dispatch(setSPDetails({ selectedTableItem: item }));
    }
  }, [item])

   const verifyLatestInCEReview = (proposalHistoryId) => {
    const latestCEUpdateHistoryId = proposalData[0]?.ceStatusList?.[0]?.proposalStatusHistoryId;
    if (proposalHistoryId === latestCEUpdateHistoryId) {
      return true;
    }
    else {
      return false;
    }
  }

  return (
    <div className={`proposal-Page-Content ${roleID===OldGlobals.USER_ROLES.CC  && selectedInnerTableRowData?.statusDetails?.statusEnglish===OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.IN_VIRTUAL_PITCH ? 'proposal-Page-Content-hop':''}`}>
      <div className="Half-Page-Header-Wrapper-prop">
        <div>
          {proposalData && proposalData?.length && (
            <>
              <p className="unsolicated-proposal-heading">
                {proposalData?.[0]?.propRefNo}{" "}
                {`- ${proposalTitle}`}
              </p>{" "}
            </>
          )}
        </div>
        <span className="HalfPage-close-icon-prop" onClick={onClose}>
          &times;
        </span>
      </div>
      {proposalData && proposalData?.length ? (
        <>
      <div className='main-nav'>
        {roleID !== Globals.USER_ROLES.PRODUCER && (
           <div className='Download-Wrapper'>
          <DownloadDocPdf key={proposalTitle} proposalDetailId={item?.proposalDetailId} proposalId={item?.proposalId} proposalType={OldGlobals.HALFSCREEN.PROPOSAL_TYPE.SOLICITED} proposalTitle={proposalTitle} />
          </div>
        )}
      <div className="HalfPage-proposal-unsolicated-briefs">
      <div className={`Half ${isExpand ? 'active' : ''}`}>
      <div
          className="brief-expandable-header"
          onClick={() => {setIsExpand(!isExpand)}}
        >
          <label className="brief-accordion-label-layout">{Globals.HALF_PAGE_BRIEF_DETAILS.BRIEF_DETAILS_HEADER}</label>
          <img
            className='drop_down_icon-proposal-unsolicited'
            onClick={() => {setIsExpand(!isExpand)}}
            src={isExpand ? Globals.IMG.ARROW_UP : Globals.IMG.ARROW_DOWN}
            alt="toggle icon"
          />
        </div>
      {isExpand && (
        <>
      <div className='details-ac'>
          {data?.length ? (
            <div>
              {contentData?.map(
                (item, index) =>
                  Object.values(item)[0] && (
                    <div key={index} className="Half-Page-Content-Wrapper">
                      <div className="Half-Page-Desc-header-layout-title">
                        { Globals.SOLICITED_BRIEFS[`${Object.keys(item)[0]}`]}
                        {/* {Globals.SOLICITED_BRIEF[`${Object.keys(item)[0]}`]} */}
                        {/* {getFieldKeys(Globals.SOLICITED_BRIEF, Object.keys(item)[0])} */}
                      </div>
                      <p className="Half-Page-Description">
                        {Object.values(item)[0]}
                      </p>
                    </div>
                  )
              )}
              <div>
                <div className="Half-Page-Form">
                  {BreifData?.map((item, index) => (
                    <div key={index} className="Half-Page-Form-Fields">
                      <div className="Half-Page-Form-fields-Bold" style={{ whiteSpace: 'pre-line' }}>
                        {item.name}
                      </div>
                      <div className="Half-Page-Form-Description">
                        {item.description}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : contentDataStatus && contentDataStatus?.length > 0 ? (
            <NoResultsComponent
              data={{
                message: Globals.HALF_PAGE_MESSAGE,
                img: Globals.IMG.HALF_PAGE_ERROR,
                submessage: Globals.HALF_PAGE_SUB_MESSAGE,
                className: 'ErrorHeader',
                subclassName: 'SubError',
                outerWrapper: 'HalfPageWrapper',
                button: 'reload',
              }}
              handleReload = {handleReload}
            />
          ) : (
            <div className="NoResultsComponent" style={{ height: '80vh' }}>
              <Loader height={50} width={50} />
            </div>
          )}
          </div></>
      )}
    </div></div>

        <div className="HalfPage-proposal-unsolicated ">
                <div className='unsolicated-gap'>
                  <div className="proposal-details-timeline">
                    {Globals.SOLICITED_PROPOSAL.PROPOSAL_TIMELINE}
                  </div>
                  <div className="proposal-status-layout">
                    {proposalData?.[0]?.proposalStatusHistories?.length > 0 ? (
                      proposalData?.[0]?.proposalStatusHistories.sort((a, b)=>new Date(a.changedAt) - new Date(b.changedAt)).map(
                        (historyItem, index) => {
                          const status = historyItem.currentStatus;
                          const changedAt = historyItem.changedAt;
                          const formattedDate = changedAt
                            ? format(new Date(changedAt), "dd MMM yyyy")
                            : null;
                          const imagePath = statusImg(status);
                          return (
                            <React.Fragment
                              key={historyItem.proposalStatusHistoryId || index}
                            >
                              <div className="proposal-status-item">
                                <div className="imgtxt">
                                  {imagePath && (
                                    <img
                                      src={imagePath}
                                      alt={statusLabels[status] || Globals.HALFSCREEN.STATUS_IMAGE}
                                      width={20}
                                      height={20}
                                    />
                                  )}
                                  <p className="status-txt">
                                    {statusLabels[status] || "Unknown Status"}
                                    {(statusLabels[status]===Globals.CC_SOLICITED_PROPOSAL_STATUS.IN_CE_REVIEW && verifyLatestInCEReview(historyItem?.proposalStatusHistoryId))&&
                                      <CEEvalStatusToolTip title={
                                        <ul style={{ margin: 0, padding: '20px' }}>
                                          {proposalData?.[0]?.ceStatusList?proposalData?.[0]?.ceStatusList?.sort((a, b) => a.ceName.trim().localeCompare(b.ceName.trim(), undefined, { sensitivity: 'base' }))
                                            .map((ce, index) => (
                                              <span key={index}>
                                                <span>{ce.ceName} - </span>
                                                <span style={{ color: ce.status === Globals.HALFSCREEN.STATUS.COMPLETED ? '#2B681D' : '#E0001B' }}>
                                                  {ce.status}
                                                </span><br/>
                                              </span>
                                            )):Globals.NO_DATA_AVAILABLE}
                                        </ul>
                                      } direction={"top-start"}>
                                        <img className="infoTooltip" src={infoIcon} alt="Info Icon" />
                                      </CEEvalStatusToolTip>
                                    }
                                  </p>
                                </div>
                                {formattedDate && (
                                  <p className="status-date">{Globals.HALFSCREEN.TIME_ON} {formattedDate}</p>
                                )}
                              </div>
                              {index <
                                proposalData?.[0]?.proposalStatusHistories?.length -
                                  1 && (
                              <img src={Globals.IMG.DASH} alt="" className='dash'/>)}
                            </React.Fragment>
                          );
                        }
                      )
                    ) : (
                      <p>{Globals.NO_STATUS}</p>
                    )}
                  </div>
                  {proposalStatus && [3, 5, 6].includes(proposalStatus) && latestComment && (
            <div className="status-comments">
                <p className="unsolicated-proposal-comments">{Globals.SOLICITED_PROPOSAL.COMMENTS}</p>
                <p className="comment-unsolicated">{latestComment}</p>
            </div>
        )}
                </div></div>

          <div className="proposal-HalfPage-pitch ">
            <div className="proposal-title">
              <div className="proposal-details">
                {Globals.SOLICITED_PROPOSAL.DETAILS}
              </div>
              <p className="text-content-company">
                  {(roleID !== Globals.USER_ROLES.PRODUCER) ? (<span className="halfscreen-producer-name" onClick={handleProducerDetails}>{proposalData?.[0]?.producerName}</span>) : (proposalData?.[0]?.producerName)}
              <span className="text">{Globals.HALFSCREEN.PRESENTS}</span>
            </p>
              <div className="proposal-title">
              <ProposalTitle title={proposalTitle} proposalId={proposalData[0]?.proposalId || proposalData?.[0]?.proposalId || ""}  proposalDetailId={proposalData[0]?.proposalDetailId || proposalData?.[0]?.proposalDetailId || ""} status={selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase()} onSave={handleTitleChange}/>
              </div>
            </div>

            <div className="proposal-container">
              <div className="proposal-half-page-left">
              <div className="proposal-heading">
                             {Globals.SOLICITED_PROPOSAL.LOGLINE}
                            </div>
                           <p className="text-content">
                {proposalData[0]?.logLine ? (
                  <>
                    {proposalData[0]?.logLine.length > 294 ? ( 
                      <>
                        {isLogLineExpanded
                          ? proposalData[0]?.logLine
                          : `${proposalData[0]?.logLine.substring(0, 294)}...`}
                          <div className='view'>
                        <span className="view-more" onClick={toggleLogLine}>
                          {isLogLineExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
                        </span></div>
                      </>
                    ) : (
                      proposalData[0]?.logLine 
                    )}
                  </>
                ) : (
                  Globals.HALFSCREEN.NA
                )}
              </p>

  <div className="proposal-heading">
                  {Globals.UNSOLICITED_PROPOSAL_HALF.SYNOPSIS}
                </div>
                <p className="text-content">
    {proposalData[0]?.synopsis ? (
      <>
        {proposalData[0]?.synopsis.length > 294 ? ( 
          <>
            {isSynopsisExpanded
              ? proposalData[0]?.synopsis
              : `${proposalData[0]?.synopsis.substring(0, 294)}...`}
              <div className='view'>
            <span className="view-more" onClick={toggleSynopsis}>
              {isSynopsisExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
            </span></div>
          </>
        ) : (
          proposalData[0]?.synopsis 
        )}
      </>
    ) : (
      Globals.HALFSCREEN.NA
    )}
  </p>


                  {(formatType===Globals.HALFSCREEN.FORMAT_TYPE.E|| formatType===Globals.HALFSCREEN.FORMAT_TYPE.M)&&<><div className="unsolicated-heading">
                                    {Globals.UNSOLICITED_PROPOSAL_HALF.EPISODE_STRUCTURE}
                                  </div>
                                   <p className="text-content">
                    {proposalData[0]?.episodeStructure ? (
                      <>
                        {proposalData[0]?.episodeStructure.length > 294 ? ( 
                          <>
                            {isepisodeStructureExpanded
                              ? proposalData[0]?.episodeStructure
                              : `${proposalData[0]?.episodeStructure.substring(0, 294)}...`}
                              <div className='view'>
                            <span className="view-more" onClick={toggleEpisode}>
                              {isepisodeStructureExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
                            </span></div>
                          </>
                        ) : (
                          proposalData[0]?.episodeStructure 
                        )}
                      </>
                    ) : (
                      Globals.HALFSCREEN.NA
                    )}
                  </p></>}

     <div className="proposal-heading">
    {Globals.SOLICITED_PROPOSAL.EDITORIAL}
    </div> 
<p className="text-content">
{proposalData[0]?.editorialDetails ? (
    <>
      {proposalData[0]?.editorialDetails.length > 294 ? ( 
        <>
          {isEditorialExpanded
            ? proposalData[0]?.editorialDetails
            : `${proposalData[0]?.editorialDetails.substring(0, 294)}...`}
            <div className='view'>
          <span className="view-more" onClick={toggleeditorial}>
            {isEditorialExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
          </span></div>
        </>
      ) : (
        proposalData[0]?.editorialDetails 
      )}
    </>
  ) : (
    Globals.HALFSCREEN.NA
  )}
</p>
                <div className="proposal-section">
                  <div className="proposal-heading">
                    {Globals.SOLICITED_PROPOSAL.PRELIMINARY}
                  </div>
                  <p className="text-content">
                    {proposalData[0]?.currency} {formatCurrency(proposalData[0]?.targetBudget)}
                  </p>
                </div>
<div className="unsolicated-heading">
                  {Globals.UNSOLICITED_PROPOSAL_HALF.LOCATION}
                </div>
   <p className="text-content">
  {proposalData[0]?.locationStudioInfo ? (
    <>
      {proposalData[0]?.locationStudioInfo.length > 294 ? ( 
        <>
          {islocationStudioInfoExpanded
            ? proposalData[0]?.locationStudioInfo
            : `${proposalData[0]?.locationStudioInfo.substring(0, 294)}...`}
            <div className='view'>
          <span className="view-more" onClick={toggleLocation}>
            {islocationStudioInfoExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
          </span></div>
        </>
      ) : (
        proposalData[0]?.locationStudioInfo 
      )}
    </>
  ) : (
    Globals.HALFSCREEN.NA
  )}
</p>
                  <div className="unsolicated-heading">
                                   {Globals.UNSOLICITED_PROPOSAL_HALF.CAST_PRESENTER_INFO}
                                 </div>
                                 <p className="text-content">
                   {proposalData[0]?.castPresenterInfo ? (
                     <>
                       {proposalData[0]?.castPresenterInfo.length > 294 ? ( 
                         <>
                           {iscastPresenterInfoExpanded
                             ? proposalData[0]?.castPresenterInfo
                             : `${proposalData[0]?.castPresenterInfo.substring(0, 294)}...`}
                             <div className='view'>
                           <span className="view-more" onClick={toggleCast}>
                             {iscastPresenterInfoExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
                           </span></div>
                         </>
                       ) : (
                         proposalData[0]?.castPresenterInfo 
                       )}
                     </>
                   ) : (
                     Globals.HALFSCREEN.NA
                   )}
                 </p>
                 <div className="unsolicated-heading">
                                   {Globals.UNSOLICITED_PROPOSAL_HALF.BRAND_INTEGRATION_OPPORTUNITIES}</div>
                                  <p className="text-content">
                   {proposalData[0]?.brandIntegration ? (
                     <>
                       {proposalData[0]?.brandIntegration.length > 294 ? ( 
                         <>
                           {isbrandIntegrationExpanded
                             ? proposalData[0]?.brandIntegration
                             : `${proposalData[0]?.brandIntegration.substring(0, 294)}...`}
                             <div className='view'>
                           <span className="view-more" onClick={toggleBrand}>
                             {isbrandIntegrationExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
                           </span></div>
                         </>
                       ) : (
                         proposalData[0]?.brandIntegration 
                       )}
                     </>
                   ) : (
                     Globals.HALFSCREEN.NA
                   )}
                 </p>
                <div className="proposal-section">
                  <div className="proposal-heading">
                    {Globals.SOLICITED_PROPOSAL.COMPANY}
                  </div>
                  <p className="text-content last">
                    {proposalData[0]?.keyTeams ? (
                     <>
                       {proposalData[0]?.keyTeams.length > 294 ? ( 
                         <>
                           {isCompanyProfileExpanded
                             ? proposalData[0]?.keyTeams
                             : `${proposalData[0]?.keyTeams.substring(0, 294)}...`}
                             <div className='view'>
                           <span className="view-more" onClick={toggleCompanyProfile}>
                             {isCompanyProfileExpanded ? Globals.HALFSCREEN.VIEW_LESS : Globals.HALFSCREEN.VIEW_MORE}
                           </span></div>
                         </>
                       ) : (
                         proposalData[0]?.keyTeams 
                       )}
                     </>
                   ) : (
                     Globals.HALFSCREEN.NA
                   )}
                  </p>
                </div>
              </div>
            <img id="line-separator" src={Globals.IMG.LINE} alt=""/>
              <div className="proposal-right-content">
            {fileItems.length > 0 ? (
                <div>
                    {fileItems.map(({foundDoc, docFor, heading}) => <DocumentListItem foundDoc={foundDoc} docFor={docFor} heading={heading}/>)} 
                </div>
            ) : (
                <p>{Globals.HALFSCREEN.NA}</p>
            )}
        </div>
            </div>
            </div>
            <div>
              {
                (roleID !== Globals.USER_ROLES.PRODUCER && roleID !== Globals.USER_ROLES.ADMIN) &&
                proposalData?.[0]?.evalStatus >= 2 && (
                  <>
                  {isAuditTrail && (            
                  <CEEvalViewAccordion
                    data={ceEvalDetails}
                    _proposalId={item.proposalId}
                    _proposalDeatilId={item.proposalDetailId}
                    getCEEvalDetails={fetchCEEvalDetails}
                    proposalStatus={proposalData?.[0]?.evalStatus}
                    ceEvalAPIFailure={ceEvalAPIFailure}
                  />
                )}
                {(!isAuditTrail&&
                <CEEvalViewAccordion
                    data={ceEvalDetails}
                    _proposalId={item.proposalId}
                    _proposalDeatilId={item.proposalDetailId}
                    getCEEvalDetails={fetchCEEvalDetails}
                    proposalStatus={proposalData?.[0]?.evalStatus}
                    ceEvalAPIFailure={ceEvalAPIFailure}
                  />
                )}
                </>
  )}
            </div>
            </div>
          <div className="Half-Page-Close-Apply-Wrapper Downloadable">
            <div className="Half-Page-Close-Apply  Downloadable-header">
              <div className="Half-Page-Close-Text" onClick={onClose}>
                {Globals.CLOSE}
              </div>
              {proposalData?.[0]?.status === 3 && roleID === OldGlobals.USER_ROLES.PRODUCER ? (
                <Button
                  title={Globals.HALFSCREEN.STATUS.RE_WORK}
                  id="Half-Screen-Rework-Button"
                  additionalStyle="Re-work"
                  disabled={isApplyButtonDisabled}
                  action={() => {
                    let row = item;
                    navigate(Globals.NAVPATH.EDIT_BRIEF, {
                      state: { row },
                    });
                  }}
                />
              ) : proposalData?.[0]?.status === 1 && roleID === OldGlobals.USER_ROLES.PRODUCER ? (
                <Button
                  title={Globals.HALFSCREEN.STATUS.EDIT_PROPOSAL}
                  id="Half-Screen-edit-Button"
                  additionalStyle="Edit-Proposal"
                  disabled={isApplyButtonDisabled}
                  action={() => {
                    let row = item;
                    navigate(Globals.NAVPATH.EDIT_BRIEF, { state: { row } });
                  }}
                />
              ) :null}
              {
              //CC Halfscreen CTA buttons rendering based on status
              
                //In CE Review Status
                (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.IN_CE_REVIEW?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.IN_CE_REVIEW?.toUpperCase())) ?
                  <>
                  </>
                  :
                  //To be assigned Status
              (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.TO_BE_ASSIGNED?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_UNSOLICITED_PROPOSAL_STATUS.TO_BE_ASSIGNED?.toUpperCase())) ?
              <>
                <Button
                  title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.REJECT_PROPOSAL}
                  id="half-page-cc-reject-proposal"
                  additionalStyle="half-page-cc-reject-proposal"
                  disabled={isApplyButtonDisabled}
                  // action={() => {
                  //   let row = item;
                  //   navigate(Globals.NAVPATH.EDIT_UNSOLICITED, {
                  //     state: { row },
                  //   });
                  // }}
                />
                <Button
                  title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_PROPOSAL}
                  id="half-page-cc-assign-proposal"
                  additionalStyle="half-page-cc-assign-proposal"
                  disabled={isApplyButtonDisabled}
                  // action={() => {
                  //   let row = item;
                  //   navigate(Globals.NAVPATH.EDIT_UNSOLICITED, {
                  //     state: { row },
                  //   });
                  // }}
                />
              </>:
                  //Invite to Virtual Pitch status
                  (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.INVITE_TO_VIRTUAL_PITCH?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.INVITE_TO_VIRTUAL_PITCH?.toUpperCase())) ?
                    <>
                      <Button
                        title={Globals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.INVITE_TO_VIRTUAL_PITCH}
                        id="half-page-cc-invite-to-vp"
                        additionalStyle="half-page-cc-invite-to-vp"
                        disabled={isApplyButtonDisabled}
                        action={()=>{
                          onClose()
                          popupShow.openPopup({isNewAcceptanceMail:true, open:true, title:Globals.INVITE_TO_VIRTUAL_PITCH.TITLE , promptText:Globals.INVITE_TO_VIRTUAL_PITCH.MESSAGE, customClassName: 'email-popup-content', normalActionText:Globals.INVITE_TO_VIRTUAL_PITCH.BUTTON_TEXT, textAreaStyle:'popup-email-text', textAreaTitle:Globals.CC_CE_COMMENTS, toastMessage :Globals.INVITE_TO_VIRTUAL_PITCH.TOAST_SUCCESS, body:proposalBody, emailContent:Globals.NEW_VIRTUAL_PITCH_EMAIL_CONTENT})
                        }}
                      />
                        {proposalData && !proposalData?.[0].isVirtualPitchCompleted && !proposalData?.[0].isVirtualPitchBySM && (
                          <>
                            {isSMRoleAvailableInCluster&&<Button
                              title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_SM_EVALUATION}
                              id="half-page-cc-assign-sm-eval-btn"
                              additionalStyle="half-page-cc-assign-sm-eval-btn"
                              disabled={isApplyButtonDisabled}
                              action={() => {
                                onClose()
                                popupShow.toggleSmEvaluation({ open: true, isSmEvaluation: true, toastMessage: Globals.SM_TOAST_SUCCESS, body: { ...proposalBody, status: 4, isVirtualPitchCompleted: proposalData?.[0].isVirtualPitchCompleted } })
                              }}
                            />}
                            {isHOPRoleAvailableInCluster&&<Button
                              title={Globals.ASSIGN_HOP_EVALUATION}
                              id="half-page-cc-assign-hop-eval"
                              additionalStyle="half-page-cc-assign-hop-eval"
                              disabled={isApplyButtonDisabled}
                              action={() => {
                                onClose()
                                popupShow.toggleHOPEvaluation({ open: true, isHOPEvaluation: true, toastMessage: Globals.HOP_TOAST_SUCCESS, body: { ...proposalBody, status: 11 } })
                              }}
                            />}
                          </>
                        )}
                    </>
                    :
                    //In Virtual Pitch status
                    (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.IN_VIRTUAL_PITCH.toLowerCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.IN_VIRTUAL_PITCH?.toUpperCase())) ?
                      <>
                      {!isUnsuccessfulMailSent && (
                        <Button
                          title={Globals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.UNSUCCESSFUL}
                          id="half-page-cc-unsuccessful-proposal"
                          additionalStyle="half-page-cc-unsuccessful-proposal"
                          disabled={isApplyButtonDisabled}
                          disable={isUnsuccessfulMailSent} //HOT FIX
                          action={()=>{
                            onClose()
                            popupShow.openPopup({ newRejection:true,open:true, title:Globals.REJECTION_MAIL_VIRTUAL_PITCH.TITLE , promptText:Globals.REJECTION_MAIL_VIRTUAL_PITCH.MESSAGE, customClassName: 'reject-email-popup-content', normalActionText:Globals.REJECTION_MAIL_VIRTUAL_PITCH.BUTTON_TEXT, textAreaStyle:'popup-email-text', textAreaTitle:Globals.CC_CE_COMMENTS, toastMessage :Globals.REJECTION_MAIL_VIRTUAL_PITCH.TOAST_SUCCESS, body:{...proposalBody, status: '7'}, emailContent:Globals.REJECTION_MAIL_VIRTUAL_PITCH.POPUP_EMAIL_HEADER})
                          }}
                        />
                      )}
                          {proposalData && !proposalData?.[0].isVirtualPitchBySM && (
                            <>
                              {isSMRoleAvailableInCluster&&<Button
                                title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_SM_EVALUATION}
                                id="half-page-cc-assign-sm-eval-btn"
                                additionalStyle="half-page-cc-assign-sm-eval-btn"
                                disabled={isApplyButtonDisabled}
                                action={() => {
                                  onClose()
                                  popupShow.toggleSmEvaluation({ open: true, isSmEvaluation: true, toastMessage: Globals.SM_TOAST_SUCCESS, body: { ...proposalBody, status: 4 } })
                                }}
                              />}
                              {/** Button for HOP Evaluation when status in In Virtual Pitch  */}
                              {isHOPRoleAvailableInCluster&&<Button
                                title={Globals.ASSIGN_HOP_EVALUATION}
                                id="half-page-cc-assign-hop-eval"
                                additionalStyle="half-page-cc-assign-hop-eval"
                                disabled={isApplyButtonDisabled}
                                action={() => {
                                  onClose()
                                  popupShow.toggleHOPEvaluation({ open: true, isHOPEvaluation: true, toastMessage: Globals.HOP_TOAST_SUCCESS, body: { ...proposalBody, status: 11 } })
                                }}
                              />}
                            </>
                          )}
                          {proposalData && proposalData?.[0].isVirtualPitchBySM && (
                            <Button
                              title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.INVITE_MANAGEMENT_PITCH}
                              id="half-page-cc-invite-management-pitch-btn"
                              additionalStyle="half-page-cc-invite-management-pitch-btn"
                              disabled={isApplyButtonDisabled}
                              action={() => {
                                onClose()
                                popupShow.openPopup({ isNewAcceptanceMail: true, open: true, title: Globals.INVITE_TO_INMANAGEMENT_PITCH.TITLE, promptText: Globals.INVITE_TO_INMANAGEMENT_PITCH.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.INVITE_TO_INMANAGEMENT_PITCH.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.INVITE_TO_INMANAGEMENT_PITCH.TOAST_SUCCESS, body: { ...proposalBody, status: '5' }, emailContent: Globals.NEW_IN_MANAGEMENT_PITCH_EMAIL_CONTENT })
                              }}
                            />
                          )}
                      </> :
                      //Rework status
                          (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.REWORK?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.REWORK?.toUpperCase())) ?
                        <>
                            {!proposalData?.[0]?.isReworkMailSent && <Button
                            title={Globals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.SEND_RE_WORK_MAIL}
                            id="half-page-cc-re-work-mail"
                            additionalStyle="half-page-cc-re-work-mail"
                            disabled={isApplyButtonDisabled}
                            action={()=>{
                              onClose()
                              popupShow.openPopup({isNewAcceptanceMail:true, open:true, title:Globals.RE_WORK.TITLE , promptText:Globals.RE_WORK.MESSAGE, customClassName: 'email-popup-content', normalActionText:Globals.RE_WORK.BUTTON_TEXT, textAreaStyle:'popup-email-text', textAreaTitle:Globals.CC_CE_COMMENTS, toastMessage :Globals.RE_WORK.TOAST_SUCCESS, body:proposalBody, emailContent:Globals.NEW_REWORK_EMAIL_CONTENT})
                            }}
                            />}
                        </> :
                        //Invite to in management pitch status
                        (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.INVITE_TO_MANAGEMENTS_PITCH?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.INVITE_TO_MANAGEMENTS_PITCH?.toUpperCase())) ?
                          <Button
                            title={Globals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.INVITE_MANAGEMENT_PITCH}
                            id="half-page-cc-invite-management-pitch"
                            additionalStyle="half-page-cc-invite-management-pitch"
                            disabled={isApplyButtonDisabled}
                            action={() => {
                              onClose()
                              popupShow.openPopup({isNewAcceptanceMail:true, open: true, title: Globals.INVITE_TO_INMANAGEMENT_PITCH.TITLE, promptText: Globals.INVITE_TO_INMANAGEMENT_PITCH.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.INVITE_TO_INMANAGEMENT_PITCH.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.INVITE_TO_INMANAGEMENT_PITCH.TOAST_SUCCESS, body: proposalBody,emailContent:Globals.NEW_IN_MANAGEMENT_PITCH_EMAIL_CONTENT })
                            }}
                          />
                          :
                          // IN management pitch
                          (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.IN_MANAGEMENT_PITCH?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.IN_MANAGEMENT_PITCH?.toUpperCase())) ?
                            <>
                            {!isUnsuccessfulMailSent && (
                              <Button
                                title={Globals.CC_UNSOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.UNSUCCESSFUL}
                                id="half-page-cc-unsuccessful-proposal"
                                additionalStyle="half-page-cc-unsuccessful-proposal"
                                disabled={isApplyButtonDisabled}
                                disable={isUnsuccessfulMailSent} //HOT FIX
                                action={() => {
                                  onClose()
                                  popupShow.openPopup({ newRejection:true, open: true, title: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.TITLE, promptText: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.MESSAGE, customClassName: 'reject-email-popup-content', normalActionText: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.TOAST_SUCCESS, body: {...proposalBody, status: 7}, emailContent:Globals.IN_MANAGEMENT_PITCH.UNSUCCESSFUL.POPUP_EMAIL_HEADER })
                                }}
                              />
                              )}
                              <Button
                                title={Globals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ACCEPTED}
                                id="half-page-cc-accepted-proposal"
                                additionalStyle="half-page-cc-accepted-proposal"
                                disabled={isApplyButtonDisabled}
                                action={() => {
                                  onClose()
                                  popupShow.openPopup({isNewAcceptanceMail:true, open: true, title: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.TITLE, promptText: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.MESSAGE, customClassName: 'email-popup-content', normalActionText: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.IN_MANAGEMENT_PITCH.ACCEPTED.TOAST_SUCCESS, body: {...proposalBody, status: 8},emailContent:Globals.NEW_ACCEPTED_EMAIL_PROPS.EMAIL_CONTENT })
                                }}
                              />
                            </> :
                            //UnsuccessFul status
                            (roleID === OldGlobals.USER_ROLES.CC && (item.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.UNSUCCESSFUL?.toUpperCase() || selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CC_SOLICITED_PROPOSAL_STATUS.UNSUCCESSFUL?.toUpperCase())) ?
                                <>
                                {!isUnsuccessfulMailSent && (
                                  <Button
                                    title={OldGlobals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.SEND_MAIL}
                                    id="half-page-cc-send-mail"
                                    additionalStyle="half-page-cc-send-mail"
                                    disabled={isApplyButtonDisabled}
                                    disable={isUnsuccessfulMailSent} // HOT FIX
                                    action={() => {
                                      onClose()
                                      popupShow.openPopup({ newRejection: true, open: true, title: Globals.UNSUCCESSFUL.TITLE, promptText: Globals.UNSUCCESSFUL.MESSAGE, customClassName: 'reject-email-popup-content', normalActionText: Globals.UNSUCCESSFUL.BUTTON_TEXT, textAreaStyle: 'popup-email-text', textAreaTitle: Globals.CC_CE_COMMENTS, toastMessage: Globals.UNSUCCESSFUL.TOAST_SUCCESS, body: proposalBody, emailContent: Globals.NEW_REWORK_EMAIL_CONTENT })
                                    }}
                                  />
                                )}
                                  {(!isUnsuccessfulMailSent && isHOPRoleAvailableInCluster && !isUnsuccessfulAfterSM)&&<Button
                                    title={Globals.ASSIGN_HOP_EVALUATION}
                                    id="half-page-cc-assign-hop-eval"
                                    additionalStyle="half-page-cc-assign-hop-eval"
                                    disabled={isApplyButtonDisabled}
                                    action={() => {
                                      onClose()
                                      popupShow.toggleHOPEvaluation({ open: true, isHOPEvaluation: true, toastMessage: Globals.HOP_TOAST_SUCCESS, body: { ...proposalBody, status: 11 } })
                                    }}
                                  />}
                                  {(!isUnsuccessfulMailSent && isSMRoleAvailableInCluster && !isUnsuccessfulAfterSM)&&<Button
                                    title={Globals.CC_SOLICITED_PROPOSAL_STATUS_CTA_BTN_TITLES.ASSIGN_SM_EVALUATION}
                                    id="half-page-cc-assign-sm-eval"
                                    additionalStyle="half-page-cc-assign-sm-eval"
                                    disabled={isApplyButtonDisabled}
                                    action={() => {
                                      onClose()
                                      popupShow.toggleSmEvaluation({ open: true, isSmEvaluation: true, toastMessage: Globals.SM_TOAST_SUCCESS, body: { ...proposalBody, status: 4 }, emailContent: Globals.SM_EMAIL_CONTENT })
                                    }}
                                  />}
                                </> :
                              /*
                              * CE Flow CTA Buttons implementation
                              */

                              //For Review Pending status
                              ((roleID === OldGlobals.USER_ROLES.CE || roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP)&&
                                selectedInnerTableRowData?.statusDetails?.statusEnglish?.toUpperCase() === OldGlobals.CE_PROPOSAL_STATUS.REVIEW_PENDING?.toUpperCase()) ?
                                <>
                                  <Button
                                    title={Globals.CE_STATUS_BTN_TITLES.REVIEW_PROPOSAL}
                                    id="half-page-ce-review-proposal"
                                    additionalStyle="half-page-ce-review-proposal"
                                    disabled={isApplyButtonDisabled}
                                    action={() => {
                                      navigateToPage();
                                    }}
                                  />
                                </>
                              :
                                null
                              }
            </div>
          </div>
        </>
      ) : contentDataStatus && contentDataStatus?.length > 0 ? (
        <>
          <NoResultsComponent
            data={{
              message: Globals.HALF_PAGE_MESSAGE,
              img: Globals.IMG.HALF_PAGE_ERROR,
              submessage: Globals.HALF_PAGE_SUB_MESSAGE,
              className: "ErrorHeader",
              subclassName: "SubError",
              outerWrapper: "HalfPageWrapper",
              imgWrapper:"HalfPageBriefImg",
              button: "reload",
            }}
            handleReload = {handleReloadProp}
          />
        </>
      ) : (
        <div className="NoResultsComponent" style={{ height: "80vh" }}>
          {" "}
          <Loader height={50} width={50} />
        </div>
      )}
    </div>
  );
}